// eslint-disable-next-line import/prefer-default-export
export const GTM_PAGE_VIEW = 'GTM Page View';
export const IITJEE_APPLICATION_NUMBER_QUESTION_ID = '119';
export const IITJEE_DOB_QUESTION_ID = '120';
export const DEFAULT_CLASS_NAME = 'Class 10';
